import I18n from 'I18n';
import { addLabelAndVerifyBadge } from '../navUtils';
import { PageTypes, Paths } from '../../../components/RoutesPublic';
import memoize from 'react-utils/memoize';
import { navigation } from 'developer-docs-source/navigation';

/**
 * 'Guides' > 'Developer Platform' nav config.
 */
export const developerPlatformNavConfig = memoize(() => {
  const commonPath = `${Paths.GUIDES}/developer-platform`;
  const nav = navigation[commonPath];
  const navigationItems = nav.items.map(item => addLabelAndVerifyBadge(item));
  const config = {
    locatorPageType: PageTypes.GUIDES,
    hasMdxOverview: true,
    sectionLabel: I18n.text('developer-docs-ui.navigation.guides.developerPlatform'),
    commonPath,
    items: navigationItems
  };
  return config;
});
export const addToConfigIfUngated = (primaryDir, userGates) => {
  return primaryDir.includes('guides') && userGates.includes('Developers:UnifiedApps:PrivateBetaDocs');
};